import {
  APP_CHECK_VIEW_PORT,
  APP_UPDATE_PROGRESS,
} from '../actions/types';

const initialState = {
  isMobile: false,
  print: false,
  progress: {
    dashboardHeader: false,
    providerDrawer: false,
    providerNavigation: false,
    providerOverview: false,
    providerTabs: false,
  },
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case APP_CHECK_VIEW_PORT:
      return { ...state, isMobile: action.payload };
    case APP_UPDATE_PROGRESS:
      return {
        ...state,
        progress: {
          ...state.progress,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
